import { HIDDEN_ROLE_TYPES } from "../../domain/entities/Role";
function mapEnvironment(raw) {
    return {
        id: Number(raw.id ?? 0),
        type: raw.type,
        reference: raw.reference,
    };
}
export function mapRole(raw) {
    return {
        id: Number(raw.id ?? 0),
        name: String(raw.name ?? ""),
        type: raw.type,
    };
}
/** Maps a raw BFF list row (UserWithActionsModel) to the UserListItem domain entity. */
export function mapResponseToUserListItem(raw) {
    return {
        id: String(raw.id ?? ""),
        name: String(raw.name ?? ""),
        email: String(raw.email ?? ""),
        enabled: raw.enabled === true,
        isInvited: raw.isInvited === true,
        lastLogin: typeof raw.lastLogin === "string" ? raw.lastLogin : null,
        environments: Array.isArray(raw.environments)
            ? raw.environments.map(mapEnvironment)
            : [],
        roles: Array.isArray(raw.roles)
            ? raw.roles
                .map(mapRole)
                .filter((role) => !HIDDEN_ROLE_TYPES.includes(role.type))
            : [],
    };
}
